import { ConfirmationSection } from '../../ConfirmationCard.types';

export interface PersonalInformationProps {
  data: {
    [key: string]: any;
  };
  confirmationSection?: ConfirmationSection;
  phonePattern?: string;
}

export enum Labels {
  cancel = 'Cancel',
  save = 'Save',
}

export enum ErrorLabels {
  emailError = 'Please insert a valid email',
  phoneError = 'Please insert a valid phone',
}

export enum FieldLabels {
  emailLabel = 'Personal email address',
  phoneLabel = 'Phone Number',
}

export const ValidateExp = {
  emailPattern:
    '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])',
};
